/**
 * Supported dashboard types
 */
export const DASHBOARD_TYPES = {
  CONTINUOUS_SCANNING: 'CONTINUOUS_SCANNING',
  PENTEST: 'PENTEST',
  GENERAL: 'GENERAL'
};

/**
 * General layout default
 * Each inner array is a row. Widgets in the same row share the space equally (flex: 1).
 * Use `grow` on a widget to give it proportionally more space (e.g. grow: 2 = double width).
 *
 * Updated 2026-06-17: Added new widgets (pentestEngagement, riskPosture, foundVsClosed,
 * findingsByAsset, newOpenPorts, newAssets) to GENERAL layout only.
 * Separate PENTEST and CONTINUOUS_SCANNING layouts will be created in future phase when backend is complete.
 */
const GENERAL_DEFAULT = [
  [
    { id: 'remediation', visible: true },
    { id: 'bySeverity', visible: true },
    { id: 'workspaceRisk', visible: true }
  ],
  [
    { id: 'generalLatestFindings', visible: true },
    { id: 'activityFeedWidget', visible: true }
  ]
];

/**
 * CONTINUOUS_SCANNING Layout default
 */
const CONTINUOUS_SCANNING_DEFAULT = [
  [
    { id: 'feeds', visible: true },
    { id: 'vulnerabilities', visible: true, grow: 2 }
  ],
  [{ id: 'statusChart', visible: true }]
];

/**
 * Pentest layout default
 */
const PENTEST_DEFAULT = [
  [
    { id: 'bySeverity', visible: true, variant: 'vertical' },
    { id: 'foundVsClosed', visible: true }
  ],
  [
    { id: 'generalLatestFindings', visible: true },
    { id: 'findingsByAsset', visible: true }
  ]
];

/**
 * Make default layout based on dashboard type
 *
 * @param {string} type - Dashboard type (CONTINUOUS_SCANNING | PENTEST | GENERAL)
 * @returns {WidgetRow[][]} - Row-based layout. Each row is an array of widget configs.
 */
export function getDefaultLayout (type) {
  const layouts = {
    [DASHBOARD_TYPES.CONTINUOUS_SCANNING]: CONTINUOUS_SCANNING_DEFAULT,
    [DASHBOARD_TYPES.PENTEST]: PENTEST_DEFAULT,
    [DASHBOARD_TYPES.GENERAL]: GENERAL_DEFAULT

    // QA - PENTEST_DEFAULT, hoy mockeamos sobre general ya que no exsste el tipo de workspace aun,
    // comentar declaracion GENERAL_DEFAULT y descomentar siguiente
    // [DASHBOARD_TYPES.GENERAL]: PENTEST_DEFAULT

    // QA - CONTINUOUS_SCANNING, hoy mockeamos sobre general ya que no exsste el tipo de workspace aun,
    // comentar declaracion GENERAL_DEFAULT y descomentar siguiente
    // [DASHBOARD_TYPES.GENERAL]: CONTINUOUS_SCANNING
  };

  return layouts[type] || GENERAL_DEFAULT;
}
